export const PROXY_SERVER = "https://roosterconnect.roosterinc.com/";

export const isLoadBalanced =
  import.meta.env.VITE_APP_API_LOAD_BALANCED === "true";

export const functionsBasePath = isLoadBalanced
  ? `${import.meta.env.VITE_APP_URL_API}/functions`
  : `https://${import.meta.env.VITE_GOOGLE_REGION_ID}-${
      import.meta.env.VITE_APP_PROJECT_ID
    }.cloudfunctions.net`;

export const BASE_URL =
  document.location.hostname === "localhost"
    ? import.meta.env.REACT_APP_MY_LOCAL_URL
      ? `${import.meta.env.REACT_APP_MY_LOCAL_URL}/functions/${
          import.meta.env.VITE_APP_PROJECT_ID
        }/${import.meta.env.VITE_GOOGLE_REGION_ID}`
      : `http://localhost:5001/${import.meta.env.VITE_APP_PROJECT_ID}/${
          import.meta.env.VITE_GOOGLE_REGION_ID
        }`
    : functionsBasePath;

export const SERVER_BASE_URL = import.meta.env.VITE_APP_URL_API;
export const USE_PROXY = import.meta.env.VITE_APP_API_USE_PROXY;

export const isLocal = () =>
  Boolean(
    window.location.hostname === "localhost" ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === "[::1]" ||
      // 127.0.0.0/8 are considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );

export const useProxy = !isLocal() && USE_PROXY === "true";

export const getProxyBaseURL = (client: string) =>
  document.location.hostname === "localhost"
    ? `${import.meta.env.VITE_APP_URL_API}`
    : `${BASE_URL}/enqueue/proxy/${client}`;

export const validateEmailUsingRegex = (email: string): boolean => {
  const emailRegex =
    /^([A-Z0-9_+-]+\.?)*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
  return emailRegex.test(email);
};
